export enum deviceMigrationActionNames {
  SET_IS_LOADING = 'SET_IS_LOADING',
}

export interface DeviceMigrationState {
  isLoading: boolean | undefined;
}

interface SetDeviceMigrationLoading {
  type: typeof deviceMigrationActionNames.SET_IS_LOADING;
  payload: boolean;
}

export type DeviceMigrationActionTypes = SetDeviceMigrationLoading;
